/** Normalize a stored handle/tag for use in a URL path. */
function cleanProfileSlug(slug: string | null | undefined): string {
  return (slug ?? '').trim().replace(/^@+/, '').toLowerCase();
}

/** Public player profile path (`/players/:slug`), or null when the slug is missing. */
export function playerProfilePath(slug: string | null | undefined): string | null {
  const clean = cleanProfileSlug(slug);
  if (!clean) return null;
  return `/players/${encodeURIComponent(clean)}`;
}

/** Public team profile path (`/teams/:slug`), or null when the slug is missing. */
export function teamProfilePath(slug: string | null | undefined): string | null {
  const clean = cleanProfileSlug(slug);
  if (!clean) return null;
  return `/teams/${encodeURIComponent(clean)}`;
}
